import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './authenticationPage.css';
import AuthenticationLoader from "../authenticationLoader/authenticationLoader";
import api from "../../services/api";
import { toast } from "react-toastify";
import constants from "../../utils/constants";

export default function AuthenticationPage() {
// const [isAutenticating,setIsAuthenticating] = useState(false);
  const nav = useNavigate();
 
 
  useEffect(() => {
    const hash = window.location.hash;
    const url = new URLSearchParams(hash.split('?')[1]);
    const token = url.get('token')  ;
    const isTokenExist = localStorage.getItem('productToken');
    const session = localStorage.getItem('session')

        verifyGenerateProductToken(token);

    
  
  }, []);



    const verifyGenerateProductToken = async(token)=>{
      try {
          const body = {
            productServiceToken  : token
          }
          let response = await api.verifyGenerateProductToken(body);
          console.log("verifyGenerateProductToken::",response);
          if (response && response.data) {
          const data = JSON.parse(response.data);
          if (response.success) {
            localStorage.setItem("session", data.sessionKey);
            localStorage.setItem("company_id", data.user_info.companyId);
            localStorage.setItem("isSuperAdmin",data.user_info.isSuperAdmin);
            localStorage.setItem("userName", data.user_info.userName)
            localStorage.setItem('allowMultipleCheckInOut',data.user_info.allowMultipleCheckInOut)
            localStorage.setItem('isCheckoutTimeEditable',data.user_info.isCheckoutTimeEditable)
            localStorage.setItem('enableAutoCheckout',data.user_info.enableAutoCheckout)
            localStorage.setItem('isCheckInTimeEditable',data.user_info.isCheckInTimeEditable)
            localStorage.setItem('isBluewingsCustomer',data.user_info.isBluewingsCustomer)
            nav(constants.navigationLink.dashboardLink);
          } else {
            toast.error(data.body, { toastId: "error7" });
          }
        }
      } catch (error) {
             toast.error("Something went wrong", { toastId: "error7" });
      }
    }

    return(
        <div className="main-container-authentication-page">

            <div className="authentication-container">
                <div className="authentication-heading">
                    Authenticating...
                </div>

                <div className="authentication-sub-container">
                    <div className="bluewings-logo">
                        <img src={('https://play-lh.googleusercontent.com/d0XseBn5z1ZhknbYxcRiPUwqMsijfGUSrwAYdeA-ggTcUUlvQJKm9zQ2eYcKP07BnoQ=w480-h960-rw')} alt="Bluewings Logo" />
                        <p className="bluewings-heading">Bluewings</p>
                    </div>
                    <AuthenticationLoader/>
                    <div className="bluewings-logo">
                        <img src={"https://hourhive-f5859.web.app/static/media/logoImage.b1aba0b2435cd18d4ec8.png"} alt="Bluewings Logo" />
                         <p className="bluewings-heading">Hourhive</p>
                    </div>

                </div>

                <div className="authentication-text">
                    Please do not close this page. It will automatically redirect you to the dashboard once authentication is successful.
                </div>

            </div>

        </div>
    )
}
